import useCommonGenerateReport from '@/core/domain/reports/commons/Report.hook';
import { ReportPurchaseParams } from '@/core/domain/reports/movements/purchase/ReportPurchase.types';
import { FILE_FORMAT, FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { Button, Checkbox, Form, Modal, ModalProps } from 'antd';
import React from 'react';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: () => void;
  setFileLoading: (fileType: FileType) => void;
  setFileUnloading: (fileType: FileType) => void;
  purchaseId?: number;
};

interface FormValues {
  showAdditionalData: boolean;
  showLocation: boolean;
}

const PurchasesPrintModal: React.FC<Props> = ({
  setFileLoading,
  setFileUnloading,
  purchaseId,
  ...props
}) => {
  const [form] = Form.useForm<FormValues>();
  const report = useReportGenerate();

  const generateReport = useCommonGenerateReport<ReportPurchaseParams>(
    '/generate/purchases-releases',
    'Relatório gerado com sucesso!',
    `Relatório de compra gerado com sucesso.`,
  );

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      if (purchaseId) {
        const values = await form.validateFields();

        const result = await generateReport.mutateAsync({
          purchaseReleaseId: purchaseId,
          format: FILE_FORMAT[format],
          showAdditionalData: values.showAdditionalData,
          showLocation: values.showLocation,
        });

        if (callback) {
          callback(result);
        }
      }
    } catch {}
    setFileUnloading(format);
  };

  return (
    <Modal
      {...props}
      title="Relatório de compras"
      width={800}
      footer={[
        <Button key="cancel" type="primary" ghost onClick={props.onCancel}>
          Cancelar
        </Button>,

        <Button
          key="yes"
          type="primary"
          loading={generateReport.isLoading}
          onClick={() =>
            handleGenerateReport('REPORT_VIEW', (result) =>
              report.openFile({
                result,
                fileName: 'relatorio_de_compra.pdf',
                fileType: 'application/pdf',
              }),
            )
          }
        >
          Imprimir
        </Button>,
      ]}
    >
      <Form form={form}>
        <Form.Item
          name="showAdditionalData"
          initialValue={false}
          valuePropName="checked"
          noStyle
        >
          <Checkbox>Exibir os dados adicionais no relatório</Checkbox>
        </Form.Item>

        <Form.Item
          name="showLocation"
          initialValue={false}
          valuePropName="checked"
          noStyle
        >
          <Checkbox>Exibir localização da peça</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PurchasesPrintModal;
